import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { StoreProvider } from './contexts/StoreContext';
import { ProductsProvider } from './contexts/ProductsContext';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';
import './index.css';

/*** SENTRY ***/
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV === "production") {
  Sentry.init({
    dsn: "https://435476445837cb72caadf89a4d7d1a09@o4507963214397440.ingest.us.sentry.io/4508487172227072",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    release: process.env.REACT_APP_RELEASE,
    sendDefaultPii: false, 
    // Tracing
    tracesSampleRate: 0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/api.sunthar\.com/],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

/*** SENTRY ***/

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router> 
      <AuthProvider>
        <StoreProvider>
          <ProductsProvider>
            <App />
          </ProductsProvider>
        </StoreProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// Pass a function to log results (for example: console.log)
// or send to an analytics endpoint.
reportWebVitals(console.log); // You can customize this part